import { useEffect } from "react";

interface SparrowEmbedProps {
  token?: string; // Survey Sparrow widget token
}

/**
 * Embeds a Survey Sparrow widget into the page
 */
const SparrowEmbed: React.FC<SparrowEmbedProps> = ({ token = "tt-qI0T630TiJf" }) => {
  useEffect(() => {
    // Create the script that defines sparrowLaunch
    const script = document.createElement("script");
    script.id = "SS_SCRIPT";
    script.text = `
      function sparrowLaunch(opts){
        var e="ss-widget", t="script", a=document, r=window, l=localStorage;
        var s, n, c, rm=a.getElementById('SS_SCRIPT');
        r.SS_WIDGET_TOKEN="${token}";
        r.SS_ACCOUNT="refinewv.surveysparrow.com";
        r.SS_SURVEY_NAME="Artists-NST---TP1-SAK-Experience";
        if(!a.getElementById(e) && !l.getItem('removed-ss-widget-${token}')){
          var S = function(){ S.update(arguments); };
          S.args = [];
          S.update = function(e){ S.args.push(e); };
          r.SparrowLauncher = S;
          s = a.getElementsByTagName(t);
          c = s[s.length - 1];
          n = a.createElement(t);
          n.type = "text/javascript";
          n.async = true;
          n.id = e;
          n.src = ["https://", "refinewv.surveysparrow.com/widget/", r.SS_WIDGET_TOKEN, "?", "customParams=", JSON.stringify(opts)].join("");
          c.parentNode.insertBefore(n, c);
          r.SS_VARIABLES = opts;
          rm.parentNode.removeChild(rm);
        }
      };
    `;
    document.body.appendChild(script);

    // Create and append the script to launch the widget.
    const launchScript = document.createElement("script");
    launchScript.text = "sparrowLaunch({/* add custom params here */})";
    document.body.appendChild(launchScript);

    // Cleanup: remove the scripts when the component unmounts.
    return () => {
      if (script.parentNode) script.parentNode.removeChild(script);
      if (launchScript.parentNode) launchScript.parentNode.removeChild(launchScript);
    };
  }, [token]);

  return (
    <div className="sparrow-embed">
      <div id="ss_survey_widget"></div>
    </div>
  );
};

export default SparrowEmbed;
